import { CreateService, CRUDServiceInterface } from '@/services/service';
import { OrderEntity } from '@/entities/order.entity';

export default class OrderService
  extends CreateService<OrderEntity>('order')
  implements CRUDServiceInterface<OrderEntity> {}
